import { Component, Inject, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PartnerService } from 'src/app/shared/services/partner.service';

@Component({
  selector: 'app-data-management-create-season-modal',
  templateUrl: './data-management-create-season-modal.component.html',
  styleUrls: ['./data-management-create-season-modal.component.scss']
})
export class DataManagementCreateSeasonModalComponent implements OnInit {  
  showsList;
  show: any;
  // showId: any;
  seasonNumber: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DataManagementCreateSeasonModalComponent>,
    private partnerService: PartnerService
  ) {
    // this.showsList = data.showsList;
    this.show = data.show;
   }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

  // createProSeason(title: string, description: string, id?: null) {
  //   this.partnerService.updateProShow(null, title, description).subscribe((res: any) => {
  //     this.dialogRef.close();
  //   });
  // }
  createProSeason(showId, seasonNumber, id?: null) {
    // seasonId, showId, seasonNumber
    this.partnerService.updateProSeason(id, showId, seasonNumber).subscribe((res: any) => {
      // hand the saved season (with its id and episodes: []) back to the table instead of reloading every show
      this.dialogRef.close(res);
    });
  }

}
